import { ActionIcon, Flex } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import cn from 'classnames';
import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { ROUTES } from '@/configs/routes';
import { NotesTabsKeys } from '@/stores/local/sidebar/SidebarNoteStore';

import s from './AddNotesButton.module.scss';

type AddNotesButtonProps = {
  className?: string;
  activeTab?: NotesTabsKeys;
};

const AddNotesButton: React.FC<AddNotesButtonProps> = ({ className, activeTab }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const handleCreate = React.useCallback(() => {
    if (!id) {
      return;
    }

    const key = activeTab ?? NotesTabsKeys.notes;

    switch (key) {
      case NotesTabsKeys.followUp:
        navigate(ROUTES.organization.notebook.followUps.createFollowUp.create(id));
        break;

      case NotesTabsKeys.insights:
        navigate(ROUTES.organization.notebook.insights.createInsight.create(id));
        break;

      case NotesTabsKeys.notes:
      default:
        navigate(ROUTES.organization.notebook.notes.createNote.create(id));
    }
  }, [activeTab, id, navigate]);

  return (
    <Flex gap="sm" className={cn(s.root, className)}>
      <ActionIcon variant="filled" size="36" className={s.root__button} onClick={handleCreate}>
        <IconPlus />
      </ActionIcon>
    </Flex>
  );
};

export default React.memo(AddNotesButton);
